

export default (filesArray, selectedProjectTypes, filterType) => {
 
    let filteredFiles=[]


// console.log(selectedProjectTypes, 'stage filter')
if (selectedProjectTypes.includes('View All') || selectedProjectTypes.length === 0) {
  filteredFiles = [...filesArray];
} else {
  filteredFiles = [...filesArray]?.filter(event =>selectedProjectTypes?.includes(event?.status_type_order))

}
    return [filteredFiles];
  };